import { Lookup } from '../../constants/lookup.interface';
import { IntakeLabelCollection } from '../../entities/intake-label.interface';
import { IntakeLabel } from '../../entities/intake-label.interface';
import { MINISTRY_NAME_LONG, MINISTRY_NAME_SHORT } from '../../constants/ministry-name';

export interface ReviewLabelsLookup extends IntakeLabel {
  label: string;
  householdSituation?: boolean;
  requiresSchedule?: boolean;
  orderedListItem?: number;
  excludeFromPdf?: boolean;
}

// export const IesReviewLabels: { [name: string]: ReviewLabelsLookup } = {
//   declarationItem13: {
//     label: 'Confirm documents included with this application:',
//     requiresSchedule: true,
//   },
// };

export const IesReviewCheckboxLabels: IntakeLabelCollection = {
  householdMe: {
    label: 'Me',
  },
  householdSpouseOrPartner: {
    label: 'My spouse/partner',
  },
  householdDependent: {
    label: 'My dependents',
  },
  requiresScheduleA: {
    label: 'Schedule A - Child Support Services',
  },
  requiresScheduleC: {
    label: 'Schedule C - Declaration of 18 or 19 year old dependent(s)',
  },
};
